export default __webpack_public_path__ + "static/media/hallelujah.7addd9ca.gif";